"use strict";

exports.__esModule = true;
exports.isPropertyEnabled = exports.getTimeZone = exports.getPropertyValue = exports.getCustomProperties = exports.getCountryCode = exports.getBusinessName = exports.getBusinessInfo = exports.getBusinessDefaultTimezone = exports.canClientChangeTimezone = exports.BusinessPropertyName = void 0;
let BusinessPropertyName = exports.BusinessPropertyName = /*#__PURE__*/function (BusinessPropertyName) {
  BusinessPropertyName["CANCELLATION_POLICY"] = "cancellationPolicy";
  BusinessPropertyName["DEFAULT_TIMEZONE"] = "defaultTimezone";
  BusinessPropertyName["CLIENT_CAN_CHANGE_TIMEZONE"] = "clientCanChangeTimezone";
  BusinessPropertyName["MULTI_SERVICES_APPOINTMENTS"] = "isMultiServicesAppointmentsEnable";
  BusinessPropertyName["IS_CART_ENABLED"] = "isCartEnabled";
  return BusinessPropertyName;
}({});
const isGetAggregatedInfoResponse = businessResponse => {
  return 'infoView' in businessResponse;
};
const getCustomProperties = businessResponse => {
  var _businessResponse$bus;
  return isGetAggregatedInfoResponse(businessResponse) ? businessResponse.customProperties || [] : ((_businessResponse$bus = businessResponse.businessProperties) == null ? void 0 : _businessResponse$bus.customProperties) || [];
};
exports.getCustomProperties = getCustomProperties;
const getBusinessInfo = businessResponse => isGetAggregatedInfoResponse(businessResponse) ? businessResponse.infoView : businessResponse.info;
exports.getBusinessInfo = getBusinessInfo;
const getPropertyValue = (businessResponse, propertyName) => {
  var _getCustomProperties$;
  return (_getCustomProperties$ = getCustomProperties(businessResponse).find(businessProperty => businessProperty.propertyName === propertyName)) == null ? void 0 : _getCustomProperties$.value;
};
exports.getPropertyValue = getPropertyValue;
const isPropertyEnabled = (businessResponse, propertyName, defaultValue = false) => {
  const value = getPropertyValue(businessResponse, propertyName);
  return value ? value === 'true' : defaultValue;
};
exports.isPropertyEnabled = isPropertyEnabled;
const getCountryCode = businessResponse => {
  var _getBusinessInfo;
  return (_getBusinessInfo = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo.countryCode;
};
exports.getCountryCode = getCountryCode;
const getTimeZone = businessResponse => {
  var _getBusinessInfo2;
  return (_getBusinessInfo2 = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo2.timeZone;
};
exports.getTimeZone = getTimeZone;
const getBusinessName = businessResponse => {
  var _getBusinessInfo3;
  return (_getBusinessInfo3 = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo3.name;
};
exports.getBusinessName = getBusinessName;
const getBusinessDefaultTimezone = businessResponse => {
  return getPropertyValue(businessResponse, BusinessPropertyName.DEFAULT_TIMEZONE);
};
exports.getBusinessDefaultTimezone = getBusinessDefaultTimezone;
const canClientChangeTimezone = businessResponse => isPropertyEnabled(businessResponse, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE, true);
exports.canClientChangeTimezone = canClientChangeTimezone;
//# sourceMappingURL=businessInfo.js.map